$(function () {
  var forEach = function (t, o, r) {
    if ('[object Object]' === Object.prototype.toString.call(t))
      for (var c in t)
        Object.prototype.hasOwnProperty.call(t, c) && o.call(r, t[c], c, t)
    else for (var e = 0, l = t.length; l > e; e++) o.call(r, t[e], e, t)
  }
  var hamburgers = document.querySelectorAll('.hamburger')
  if (hamburgers.length > 0) {
    forEach(hamburgers, function (hamburger) {
      hamburger.addEventListener(
        'click',
        function () {
          this.classList.toggle('is-active')
          $('.header').toggleClass('show')
        },
        false
      )
    })
  }

  $('.sameHeight').matchHeight()

  //  Equal height - by Lewi Hussey

  var matchHeight = (function () {
    function init () {
      eventListeners()
      matchHeight()
    }

    function eventListeners () {
      $(window).on('resize', function () {
        matchHeight()
      })
    }

    function matchHeight () {
      var groupName = $('[data-match-height]')
      var groupHeights = []

      groupName.css('min-height', 'auto')

      groupName.each(function () {
        groupHeights.push($(this).outerHeight())
      })

      var maxHeight = Math.max.apply(null, groupHeights)
      groupName.css('min-height', maxHeight)
    }

    return {
      init: init
    }
  })()

  $(document).ready(function () {
    matchHeight.init()
  })
  // Swiper
  var mySwiper = new Swiper('.swiper-container', {
    speed: 400,
    autoplay: {delay: 5000},
    effect: 'fade',
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    preloadImages: true
  })

  $('#overlay-btn').click(function () {
    $('#overlay').toggleClass('open')
    $('body').toggleClass('noscroll')
  })

  $('.cancel_sub').click(function () {
    $('#overlay').toggleClass('open')
    $('body').toggleClass('noscroll')
  })

//Leistungsgeneratorformular

  var selectModel = $('#model')
  var placeholder = selectModel.data('placeholder')
  var selectVorlauftemperatur = $('#vorlauftemperatur')
  var selectRuecklauftemperatur = $('#ruecklauftemperatur')
  var selectRaumlufttemperatur = $('#raumlufttemperatur')
  var selectRuecklauftemperaturCold = $('#ruecklauftemperatur_cold')
  var selectRaumlufttemperaturCold = $('#raumlufttemperatur_cold')
  var selectVorlauftemperaturCold = $('#vorlauftemperatur_cold')
  var sectionCold = $('#section_cold')

  function select2OptionFormat(option) {
    if (option.text.indexOf(' (')) {
      return option.text.replace(' (', '<br>(');
    }

    return option.text;
  }

  var selectConfigBlue = {
    minimumResultsForSearch: -1,
    theme: 'default blue_option',
    placeholder: placeholder
  }
  var selectConfigOrange = {
    minimumResultsForSearch: -1,
    theme: 'default orange_option',
    placeholder: placeholder
  }

  selectVorlauftemperaturCold.select2(selectConfigBlue)
  selectRaumlufttemperaturCold.select2(selectConfigBlue)
  selectRuecklauftemperaturCold.select2(selectConfigBlue)
  selectRaumlufttemperatur.select2(selectConfigOrange)
  selectRuecklauftemperatur.select2(selectConfigOrange)
  selectVorlauftemperatur.select2(selectConfigOrange)
  selectModel.select2({
    minimumResultsForSearch: -1,
    placeholder: placeholder,
    templateResult: select2OptionFormat,
    escapeMarkup: function(m) { return m; }
  })

  selectModel.change(function () {
    sectionCold.css('display', 'none')
    selectVorlauftemperaturCold.prop('required', false)
    selectRaumlufttemperaturCold.prop('required', false)
    selectRuecklauftemperaturCold.prop('required', false)
    if ($('option:selected', this).data('cold')) {
      sectionCold.css('display', 'block')
      selectVorlauftemperaturCold.prop('required', true)
      selectRaumlufttemperaturCold.prop('required', true)
      selectRuecklauftemperaturCold.prop('required', true)
    }
    $('.select').val(null).change().prop('disabled', true)
    selectVorlauftemperatur.prop('disabled', false)
    selectVorlauftemperaturCold.prop('disabled', false)

  })

  selectVorlauftemperatur.change(function () {
    selectRuecklauftemperatur.prop('disabled', false)
    selectRuecklauftemperatur.val(null).change()
    selectRaumlufttemperatur.prop('disabled', true)
    selectRaumlufttemperatur.val(null).change()

    var options = []
    $('option', selectRuecklauftemperatur).each(function () {
      var self = $(this)
      $(this).prop('disabled', false)
      if (parseInt(self.val()) > parseInt(selectVorlauftemperatur.val()) - 5
        || parseInt(self.val()) < parseInt(selectVorlauftemperatur.val()) - 20) {
        $(this).prop('disabled', true)
        options.push({
          text: self.text(),
          id: self.text(),
          disabled: true
        })
      } else {
        options.push({
          text: self.text(),
          id: self.text(),
          disabled: false
        })
      }
    })

    selectRuecklauftemperatur.empty().select2(
      Object.assign({}, selectConfigOrange, {data: options})
    )
  })

  selectRuecklauftemperatur.change(function () {
    selectRaumlufttemperatur.prop('disabled', false)
    selectRaumlufttemperatur.val(null).change()
  })

  selectVorlauftemperaturCold.change(function () {
    selectRuecklauftemperaturCold.prop('disabled', false)
    selectRuecklauftemperaturCold.val(null).change()
    selectRaumlufttemperaturCold.prop('disabled', true)
    selectRaumlufttemperaturCold.val(null).change()

    var options = []

    $('option', selectRuecklauftemperaturCold).each(function () {
      var self = $(this)
      var disabled = false
      $(this).prop('disabled', false)
      if (parseInt(self.val()) < parseInt(selectVorlauftemperaturCold.val()) + 2
        || parseInt(self.val()) > parseInt(selectVorlauftemperaturCold.val()) + 6) {
        $(this).prop('disabled', true)
        disabled = true
      }
      options.push({
        text: self.text(),
        id: self.text(),
        disabled: disabled
      })
    })

    selectRuecklauftemperaturCold.empty().select2(
      Object.assign({}, selectConfigBlue, {data: options}))
  })

  selectRuecklauftemperaturCold.change(function () {
    selectRaumlufttemperaturCold.prop('disabled', false)
    selectRaumlufttemperaturCold.val(null).change()
  })

  //inputfield resize
  function resizable (el, factor) {
    var int = Number(factor) || 7.7

    function resize () {el.style.width = ((el.value.length + 1) * int) + 'px'}

    var e = 'keyup,keypress,focus,blur,change'.split(',')
    for (var i in e) el.addEventListener(e[i], resize, false)
    resize()
  }
  if (document.getElementById('email')) {
    resizable(document.getElementById('email'), 7)
    resizable(document.getElementById('name'), 7)
  }
//end of generator
})
